// src/components/Alumni.js

import React, { useEffect, useRef } from 'react';
import Slider from 'react-slick';
import './Alumni.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import sanskrutiPhoto from '../assets/aluminiimages/Sanskruti Tripathy.png';
import nilachalaPhoto from '../assets/aluminiimages/1728885810170 - Nilachala Sahoo.jpg';
import anishaPhoto from '../assets/aluminiimages/anisha.jpg';
import biswajitPhoto from '../assets/aluminiimages/biswajit.jpg';

import tcsLogo from '../assets/companylogo/tcs.png';
import niLogo from '../assets/companylogo/ni.jpeg';

// Alumni data with updated information
const alumniData = [
  {
    name: 'Sanskruti Tripathy',
    photo: sanskrutiPhoto,
    companyLogo: tcsLogo,
    companyName: 'TCS',
    title: 'Software Developer'
  },
  {
    name: 'Nilachala Sahoo',
    photo: nilachalaPhoto,
    companyLogo: niLogo,
    companyName: 'National Instruments',
    title: 'Software Engineer'
  },
  {
    name: 'Isha Priyadarshini Panda',
    photo: anishaPhoto,
    companyLogo: tcsLogo,
    companyName: 'TCS',
    title: 'Software Developer'
  },
  {
    name: 'Biswajit Mishra',
    photo: biswajitPhoto,
    companyLogo: tcsLogo,
    companyName: 'TCS',
    title: 'Software Developer'
  },
  // Add more alumni here
];

const Alumni = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (sliderRef.current) {
        sliderRef.current.slickNext();
      }
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section id="alumni" className="alumni-section">
      <h2 className="alumni-title">Our Alumni</h2>
      <Slider ref={sliderRef} {...settings}>
  {alumniData.map((alum, index) => (
    <div key={index} className="alumni-card">
      <div className="alumni-photo-wrapper">
        <img src={alum.photo} alt={`${alum.name}'s photo`} className="alumni-photo" />
      </div>
      <div className="alumni-info">
        <h3>{alum.name}</h3>
        <p>{alum.title}</p>
        <div className="company-logo-container">
          <img src={alum.companyLogo} alt={alum.companyName} className="company-logo" />
          <p>{alum.companyName}</p>
        </div>
      </div>
    </div>
  ))}
</Slider>

    </section>
  );
}

export default Alumni;
